import { Card, Typography, Button, Select, Option } from "@material-tailwind/react";
import { TableWithButtonAndDropdownModel, TableWithButtonModel } from "./tableModel";
import { TableDataWidth } from "../../app/common";
import { useTranslation } from "react-i18next";
import { useState } from "react";

export function TableWithButton({ tableHead, tableBody, onClickFunction }: TableWithButtonModel) {
    const { t } = useTranslation();
    if (tableBody === undefined || tableBody.length === 0) {
        return <Typography variant="small" color="blue-gray" className=" leading-none text-#333333">{t("NoData")}</Typography>
    }
    return (
        <div className="overflow-auto">
            <Card className="h-full w-full border-hidden overflow-y-auto ">
                <table className="w-full min-w-max table-auto text-left">
                    <thead>
                        <tr>
                            {tableHead.map((head) => (
                                <th key={head} className=" bg-#F6F6F6 p-4 font-thin">
                                    <Typography variant="small" color="blue-gray" className=" font-semibold leading-none">
                                        {head}
                                    </Typography>
                                </th>
                            ))}
                        </tr>
                    </thead>

                    <tbody>
                        {tableBody.map(({ tableData, itemId, buttonColor }, index) => (
                            <tr key={index} className="even:bg-blue-gray-50/50">
                                {tableData.map((data, index) => {
                                    const isLast = index === tableData.length - 1;
                                    let buttonColorCss = "bg-[#FA9194] hover:bg-[#EA4247]";
                                    if (buttonColor === "green") {
                                        buttonColorCss = "bg-[#A3B974] hover:bg-[#83A639]";
                                    }
                                    return (
                                        <td key={data + index} className={"p-4 " + TableDataWidth}>
                                            {isLast === true ? <Button id="tableBtn" className={`text-[#161616] ${buttonColorCss} hover:shadow-none`}
                                                onClick={() => onClickFunction(itemId)}>{data}</Button> :
                                                <Typography variant="small" color="blue-gray" className="font-normal">
                                                    {data}
                                                </Typography>
                                            }
                                        </td>
                                    )
                                })}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </Card>
        </div>
    );
}


export function TableWithButtonAndDropdown({ tableHead, tableBody, onClickFunction, dropdownOptions }: TableWithButtonAndDropdownModel) {
    const [selectedUser, setSelectedUser] = useState<string>("");
    const { t } = useTranslation();
    if (tableBody === undefined || tableBody.length === 0) {
        return <Typography variant="small" color="blue-gray" className=" leading-none text-#333333">{t("NoData")}</Typography>
    }

    const onOptionChange = (choice: string) => {
        setSelectedUser(choice);
    }

    return (
        <div className="overflow-auto">
            <Card className="h-full w-full border-hidden overflow-y-auto ">
                <table className="w-full min-w-max table-auto text-left">
                    <thead>
                        <tr>
                            {tableHead.map((head) => (
                                <th key={head} className=" bg-#F6F6F6 p-4 font-thin">
                                    <Typography variant="small" color="blue-gray" className=" font-semibold leading-none">
                                        {head}
                                    </Typography>
                                </th>
                            ))}
                        </tr>
                    </thead>

                    <tbody>
                        {tableBody.map(({ tableData, itemId, buttonColor }, index) => (
                            <tr key={index} className="even:bg-blue-gray-50/50">
                                {tableData.map((data, index) => {
                                    const isLast = index === tableData.length - 1;
                                    let buttonColorCss = "bg-[#FA9194] hover:bg-[#EA4247]";
                                    if (buttonColor === "green") {
                                        buttonColorCss = "bg-[#A3B974] hover:bg-[#83A639]";
                                    }
                                    return (
                                        <td key={data + index} className={"p-4 " + TableDataWidth}>
                                            {isLast === true ? <Button id="tableBtn" className={`text-[#161616] ${buttonColorCss} hover:shadow-none`}
                                                onClick={() => onClickFunction(itemId, selectedUser)}>{data}</Button> :

                                                data === "" ?
                                                    <Select id="SelectUserAssignLicense" aria-label={t("SelectUser")}
                                                        label={t("SelectUser")} labelProps={{ className: "!text-[#3D3D3D] peer-focus:!text-[#F97316]" }}
                                                        className=" rounded text-[#3D3D3D]" color="orange"
                                                        error={false} onChange={(choice) => onOptionChange(choice ? choice : "")}
                                                        defaultValue={""}>
                                                        {
                                                            dropdownOptions.map((option, index) => {
                                                                return (
                                                                    <Option id={index.toString()} key={option.selectedOption + index} value={option.selectionData} className="text-[#3D3D3D]">{option.selectedOption}</Option>
                                                                )
                                                            })
                                                        }
                                                    </Select>

                                                    :
                                                    <Typography variant="small" color="blue-gray" className="font-normal">
                                                        {data}
                                                    </Typography>


                                            }
                                        </td>
                                    )
                                })}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </Card>
        </div>
    );
}